(function () {
  function injectOverlay() {
    if (document.querySelector('.cda-warranty-overlay')) return;

    var vendorEl = document.querySelector('.pdp-vendor-name, .pdp-vendor-logo');
    var isCDA = false;
    if (vendorEl) {
      var text = vendorEl.textContent || (vendorEl.querySelector('img') && vendorEl.querySelector('img').alt) || '';
      isCDA = text.trim().toUpperCase().indexOf('CDA') !== -1;
    }
    if (!isCDA) isCDA = document.title.toUpperCase().indexOf('CDA') !== -1;
    if (!isCDA) return;

    // Inject styles into <head>
    if (!document.getElementById('cda-warranty-style')) {
      var style = document.createElement('style');
      style.id = 'cda-warranty-style';
      style.textContent = [
        '.cda-warranty-overlay {',
        '  position: absolute !important;',
        '  bottom: 12px !important;',
        '  right: 10px !important;',
        '  left: auto !important;',
        '  top: auto !important;',
        '  z-index: 100 !important;',
        '  pointer-events: none !important;',
        '  width: 96px !important;',
        '  height: auto !important;',
        '}',
        '.cda-warranty-overlay img {',
        '  width: 96px !important;',
        '  height: auto !important;',
        '  display: block !important;',
        '  position: static !important;',
        '  top: auto !important;',
        '  left: auto !important;',
        '  max-width: none !important;',
        '  object-fit: unset !important;',
        '}',
        '@media (max-width: 749px) {',
        '  .cda-warranty-overlay { width: 72px !important; bottom: 10px !important; right: 8px !important; }',
        '  .cda-warranty-overlay img { width: 72px !important; }',
        '}'
      ].join('\n');
      document.head.appendChild(style);
    }

    // Find the first .media element — this is the actual image box on all screen sizes
    var target = document.querySelector(
      '.product__media-list .product__media-item:first-child .media, ' +
      '.product__media-list .slider__slide:first-child .media, ' +
      '.product__media-list li:first-child .media'
    );

    if (!target) return;

    var overlay = document.createElement('div');
    overlay.className = 'cda-warranty-overlay';
    var img = document.createElement('img');
    img.src = 'https://cdn.shopify.com/s/files/1/0935/2999/7686/files/CDA_Warranty.webp?v=1781256585';
    img.alt = 'CDA Lifetime Parts Warranty';
    img.loading = 'eager';
    overlay.appendChild(img);
    target.appendChild(overlay);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', injectOverlay);
  } else {
    injectOverlay();
  }
})();
